/* @ngInject */
const saleLocal = (
  valueHandler,
  storageHandler
) => {
  const self = {}

  self.saveCurrentId = (_id) => {
    if (valueHandler.isId(_id)) {
      storageHandler.save('currentSaleId', _id)
    } else if (valueHandler.isId(_id.id)) {
      storageHandler.save('currentSaleId', _id.id)
    }
  }

  self.getCurrentId = () => {
    return storageHandler.get('currentSaleId')
  }

  return self
}
export default saleLocal



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/services/local.service.js